import privacyNoticeEn from "./en";
import privacyNoticeMs from "./ms";

export const DEFAULT_PRIVACY_LANGUAGE = "en";

export const PRIVACY_LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "ms", label: "Bahasa Melayu", short: "BM" },
];

export const PRIVACY_NOTICES = {
  en: privacyNoticeEn,
  ms: privacyNoticeMs,
};

// UI copy around the notice (checkbox, modal chrome). The notice text itself lives in ./en.js and ./ms.js.
export const PRIVACY_UI_TEXT = {
  en: {
    consentPrefix: "I have read and accept the",
    linkText: "Privacy Notice",
    consentHint: "Tick this box to continue with your registration.",
    language: "Language",
    agree: "I Agree",
    close: "Close",
    closeLabel: "Close privacy notice",
    scrollRegion: "Privacy notice text",
  },
  ms: {
    consentPrefix: "Saya telah membaca dan menerima",
    linkText: "Notis Privasi",
    consentHint: "Tandakan kotak ini untuk meneruskan pendaftaran anda.",
    language: "Bahasa",
    agree: "Saya Setuju",
    close: "Tutup",
    closeLabel: "Tutup notis privasi",
    scrollRegion: "Teks notis privasi",
  },
};
